<template>
  <div id="loading-screen" v-if="showDialog">
    <div id="loading-wrapper">
      <div id="loading-bar"></div>
      <div id="loading-content">
        <slot></slot>
      </div>
      <div v-if="page==='shop'" class="no-result" >{{ currentWarning }}</div>
      <div v-else-if="page==='store'" class="no-result">{{ currentWarning }}</div>
      <div v-else-if="title" class="no-result">{{ title }}</div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    page:String,
    title:String,
  },
  setup(props) {
    const { t } = useI18n()
    const shopList = [
      `${t('sentence.loading1')}`,
      `${t('sentence.loading2')}`,
      `${t('sentence.loading3')}`
    ]
    const storeList = [
      `${t('sentence.loading4')}`,
      `${t('sentence.loading5')}`,
      `${t('sentence.loading6')}`
    ]
    let currentWarning 
    if(props.page === undefined || props.page === '') currentWarning = ref(`${t('sentence.wait')}`)
    else if(props.page === 'shop') currentWarning = ref(shopList[0])
    else if(props.page === 'store') currentWarning = ref(storeList[0])

    let warningIndex = 0
    let warningInterval

    const rotateWarning = () => {
      if(props.page === 'shop') {
        warningIndex = (warningIndex + 1) % shopList.length
        currentWarning.value = shopList[warningIndex]
      } else if(props.page === 'store') {
        warningIndex = (warningIndex + 1) % storeList.length
        currentWarning.value = storeList[warningIndex]
      }
    }

    onMounted(() => {
      warningInterval = setInterval(rotateWarning, 2000)
    })

    onUnmounted(() => {
      clearInterval(warningInterval)
    })
    return {
      currentWarning
    }
  },

  methods: {
    closeDialog() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
#loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999999999999999999;
  display: flex;
  justify-content: center;
  align-items: center;
}

#loading-wrapper {
  width: 400px;
  height: 200px;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

#loading-bar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 10px solid rgba(0, 0, 0, 0.1);
  border-top-color: #FF7F50;
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 20px;
}

#loading-content {
  text-align: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>